import './version.scss';

import { GetApiVersionDocument } from '../../../data/types/api/graphql';
import { useCacheQuery } from '../../../hooks/use-cache-query';

export function Version() {
  const { data } = useCacheQuery(GetApiVersionDocument);

  return (
    <span className="version">
      Versie:
      <div>
        {`${import.meta.env.PACKAGE_VERSION} ${
          import.meta.env.VITE_VERSION
            ? ` : ${import.meta.env.VITE_VERSION}`
            : ''
        }`}
      </div>
      Api:
      <div>{data?.apiVersion ?? ''}</div>
    </span>
  );
}
